export default __webpack_public_path__ + "static/media/full-stack.18fb4a35.svg";